const getters = {
  sidebar: state => state.app.sidebar,
  size: state => state.app.size,
  device: state => state.app.device,
  MembershipType: state => state.app.MembershipType,
  visitedViews: state => state.tagsView.visitedViews,
  cachedViews: state => state.tagsView.cachedViews,
  token: state => state.user.token,
  accessToken: state => state.user.accessToken,
  avatar: state => state.user.avatar,
  name: state => state.user.name,
  userTypeList: state => state.user.userTypeList,
  isSelf: state => state.user.isSelf,
  schoolName: state => state.user.schoolName,
  id: state => state.user.id,
  // introduction: state => state.user.introduction,
  roles: state => state.user.roles,
  getInfo: state => state.user.getInfo,
  permissionRoutes: state => state.permission.routes,
};
export default getters;
